<template>
  <label class="ui-check">
    <input type="checkbox" :checked="value" @change="$emit('input', $event.target.checked)" />
    <span>
      <slot></slot>
      <small v-if="hint">{{ hint }}</small>
    </span>
  </label>
</template>

<script>
/** Polje za potvrdu sa nazivom (slot) i napomenom ispod (hint). v-model je boolean. */
export default {
  name: "UiCheck",
  props: {
    value: { type: Boolean, default: false },
    hint: { type: String, default: "" },
  },
};
</script>
